
import { computed, ComputedRef, defineComponent, onMounted, onUnmounted, ref, WritableComputedRef } from 'vue'
import { useStore } from '@/store'
import ToolbarButton from '@/components/Toolbar/ToolbarButton.vue'
import { Tools } from '@/store/state'
import { ColorPicker } from 'vue-color-kit'
import { loadFile } from '@/domain/Utils'

export default defineComponent({
    name: 'MainToolbar',
    components: {
        ToolbarButton,
        ColorPicker
    },
    setup: function () {
        const store = useStore()
        const openPicker = ref('')
        const clickOutside = (e: Event) => {
            const el = e.target as HTMLElement

            if (!el.classList.contains('button-picker') && !el.closest('.button-picker') && !el.classList.contains('color-picker') && !el.closest('.color-picker')) {
                openPicker.value = ''
            }
        }

        onMounted(() => {
            document.addEventListener('click', clickOutside)
        })

        onUnmounted(() => {
            document.removeEventListener('click', clickOutside)
        })

        const newTrinket = () => {
            store.dispatch('newTrinket')
        }

        const loadTrinket = async (e: Event) => {
            const files = (e.target as HTMLInputElement).files

            const res = await loadFile(files)
            store.dispatch('loadTrinket', (res.target as FileReader).result)
        }

        const saveTrinket = () => {
            store.dispatch('saveTrinket')
        }

        const exportTrinket = () => {
            store.dispatch('exportTrinket')
        }

        const print = () => {
            window.print()
        }

        const selectTool = (tool: Tools) => {
            store.dispatch('selectTool', tool)
        }

        const openOptions = () => {
            store.dispatch('openSettings')
        }

        const palette = computed(() => store.state.palette)
        const selectedTool: ComputedRef<Tools> = computed(() => store.state.trinketGrid.selectedTool)
        const fillColor: WritableComputedRef<string> = computed({
            get: () => store.state.trinketGrid.colors.fill,
            set: color => store.dispatch('updateColor', {
                color,
                zone: 'fill'
            })
        })
        const strokeColor: WritableComputedRef<string> = computed({
            get: () => store.state.trinketGrid.colors.stroke,
            set: color => store.dispatch('updateColor', {
                color,
                zone: 'stroke'
            })
        })
        const lineStrokeColor: WritableComputedRef<string> = computed({
            get: () => store.state.trinketGrid.colors.lineStroke,
            set: color => store.dispatch('updateColor', {
                color,
                zone: 'lineStroke'
            })
        })

        return {
            newTrinket,
            saveTrinket,
            loadTrinket,
            exportTrinket,
            print,
            selectTool,
            openOptions,
            palette,
            Tools,
            selectedTool,
            fillColor,
            strokeColor,
            lineStrokeColor,
            openPicker
        }
    }
})
